(() => {
  const initializeCategoryScroller = (section) => {
    if (!section || section.dataset.categoryScrollerReady === 'true') return;

    const scroller = section.querySelector('[data-category-scroll]');
    const previousButton = section.querySelector('[data-category-prev]');
    const nextButton = section.querySelector('[data-category-next]');
    if (!scroller || !previousButton || !nextButton) return;

    section.dataset.categoryScrollerReady = 'true';
    scroller.scrollLeft = 0;

    const updateControls = () => {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      previousButton.disabled = scroller.scrollLeft <= 2;
      nextButton.disabled = scroller.scrollLeft >= maxScroll - 2;
      section.classList.toggle('is-scrollable', maxScroll > 2);
    };

    const scrollCategories = (direction) => {
      scroller.scrollBy({
        left: direction * Math.max(scroller.clientWidth * 0.72, 280),
        behavior: 'smooth'
      });
    };

    previousButton.addEventListener('click', () => scrollCategories(-1));
    nextButton.addEventListener('click', () => scrollCategories(1));
    scroller.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    requestAnimationFrame(updateControls);
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('.promotion-blocks--category_tiles').forEach(initializeCategoryScroller);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
